/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
// src/themes/theme1/utils/theme1Constants.js
export const ORDER_STATUS = { PENDING: 1 };

export const THEME_NAME_TO_ID = {
  "Pink Glow": 1,
  "Purple Dream": 2,
  "Golden Luxe": 3,
  "Turquoise Glow": 4,
};

export const THEMES = {
  1: {
    name: "Pink Glow",
    primary: "#EC4899", // pink-500
    primaryDark: "#DB2777", // pink-600
    primaryLight: "#F472B6", // pink-400
    accent: "#FCD34D", // amber-300
    accentDark: "#F59E0B", // amber-500
    gradient: "from-pink-500 via-fuchsia-500 to-amber-300",
    bgGradient: "from-[#000000] via-[#0a0408] to-[#0f050a]",
  },
  2: {
    name: "Purple Dream",
    primary: "#A855F7", // purple-500
    primaryDark: "#9333EA", // purple-600
    primaryLight: "#C084FC", // purple-400
    accent: "#F0ABFC", // fuchsia-300
    accentDark: "#D946EF", // fuchsia-500
    gradient: "from-purple-500 via-violet-500 to-fuchsia-300",
    bgGradient: "from-[#000000] via-[#080410] to-[#0a0510]",
  },
  3: {
    name: "Golden Luxe",
    primary: "#F59E0B", // amber-500
    primaryDark: "#D97706", // amber-600
    primaryLight: "#FBBF24", // amber-400
    accent: "#FCD34D", // amber-300
    accentDark: "#F59E0B", // amber-500
    gradient: "from-amber-500 via-yellow-500 to-amber-300",
    bgGradient: "from-[#000000] via-[#0a0804] to-[#0f0a05]",
  },
  4: {
    name: "Turquoise Glow",
    primary: "#14B8A6", // teal-500
    primaryDark: "#0D9488", // teal-600
    primaryLight: "#2DD4BF", // teal-400
    accent: "#5EEAD4", // teal-300
    accentDark: "#14B8A6", // teal-500
    gradient: "from-teal-500 via-cyan-500 to-teal-300",
    bgGradient: "from-[#000000] via-[#040a0a] to-[#050f0f]",
  },
};


